import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
/**
 * this service can be used to send the data and receive the data (publish and subscription based mechanism)
 */
export class PubSubService {
    private loader = new Subject();
    private profileUpdaterSub = new Subject();
    private req = 0;
    private menuBarSub = new Subject();

    /**
     * method used to start the loader and stop the loader
     * @param isloader {boolean} if true then loader will start, false will stop the loader by default is false
     */
    startStopLoader(isloader: boolean = false) {
        if (isloader) {
            if (this.req === 0) {
                this.loader.next(true);
            }
            this.req++;
        }
        else {
            this.req--;
            if (this.req === 0) {
                this.loader.next(false);
            }
            else if (this.req <= 0) {
                this.req = 0;
            }
        }
    }
    /**
     * subscribe event
     */
    getloader = this.loader.asObservable();
    /**
     * observable for profile update action
     */
    profileUpdater = this.profileUpdaterSub.asObservable();

    /**
     * event sender used when profile is updated
     */
    updateProfile() {
        this.profileUpdaterSub.next(true);
    }


    menuBarObservable = this.menuBarSub.asObservable();
    sendMenuUpdateEvent(val: boolean) {
        this.menuBarSub.next(val);
    }


}